/**
 * Development logging utility for paywall-manager
 * Only logs in development environment
 */

import { ENVS } from "src/v2/shared/environment.config";

const isDevelopment = ENVS.environment === "development";

export const prodLog = (...args: unknown[]) => {
  console.log(...args);
};

export const devLog = (...args: unknown[]) => {
  if (isDevelopment) {
    console.log(...args);
  }
};

export const devError = (...args: unknown[]) => {
  if (isDevelopment) {
    console.error(...args);
  }
};

export const devWarn = (...args: unknown[]) => {
  if (isDevelopment) {
    console.warn(...args);
  }
};
